import { Box, Button, Paper, Typography } from '@mui/material';
// Components
import QRCopy from '../QRCopy/QRCopy';
// Hooks
import { useIsMobile } from '@/hooks/useIsMobile';
// Utils
import { brand } from '@/brand/brand';
import { isErc20EvmCryptoAsset } from '@nerdcoresdk/foundations-crypto';
// Styles
import styles from './addFunds.module.css';

export default function AddFunds({ close, walletInfo }) {
  const largeMobile = useIsMobile(820);
  const smallMobile = useIsMobile(520);
  const paymentNetworkLabel =
    walletInfo?.cryptoAsset && isErc20EvmCryptoAsset(walletInfo.cryptoAsset)
      ? `the ERC-20 version of ${walletInfo?.cryptoAsset?.display.symbol} over the Ethereum Mainnet`
      : `${walletInfo?.cryptoAsset?.display.symbol} over the Ethereum Mainnet`;

  return (
    <Paper>
      <Box sx={{ paddingBottom: '16px' }}>
        <Typography variant="h3" data-core-qa="addFundsTitleText">
          Add {walletInfo?.cryptoAsset?.display.symbol} to Your {brand.brandName} Wallet
        </Typography>
      </Box>
      <div>
        <div className={styles.gridWrapper}>
          <div className={styles.textWrapper}>
            <Typography
              variant="body1"
              className={styles.text}
              data-core-qa="addFundsSubText"
            >
              Scan the QR code OR copy and paste the wallet address below into your
              Ethereum Mainnet compatible wallet. After sending please refresh the
              purchase page until your funds appear.
            </Typography>

            <Typography variant="body1" className={styles.text} data-core-qa="addFundsL1">
              Transaction times vary, possibly taking 5-10 minutes or longer if the
              network is busy.
            </Typography>
            <Typography variant="body1" className={styles.text} data-core-qa="addFundsL2">
              Please be sure to take into account the cost of gas fees when deciding how
              much to send.
            </Typography>
            <Typography variant="body1" className={styles.text}>
              Only send {paymentNetworkLabel}.
            </Typography>
          </div>
          <div className={styles.buttonsArea}>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                close();
              }}
              fullWidth={largeMobile}
              data-core-qa="addFundsButtonReturn"
            >
              Return to Checkout
            </Button>
          </div>
          <div className={styles.qrArea} data-core-qa="qrCode">
            <QRCopy
              coin={walletInfo?.cryptoAsset?.display.symbol}
              copyAddress={walletInfo?.walletId}
              qrSize={smallMobile ? 150 : 76}
              isVertical={smallMobile}
            />
          </div>
        </div>
      </div>
    </Paper>
  );
}
